import Accordion from '../Accordion';
import Forms from '../Forms';
import layout from '../Layout';

export default class StaticSectionFooter {
  constructor(section) {
    this.$el = $(section.el);
    this.Accordion = new Accordion(this.$el);

    this.forms = new Forms(this.$el);

    // Handle Accordion interaction when window size changes
    this.layoutHandler = this.onBreakpointChange.bind(this);
    layout.onBreakpointChange(this.layoutHandler);

    this._bindEvents();
  }

  _bindEvents() {
    this.$el.on('click.footer', '[data-accordion-trigger]', event => {
      event.preventDefault();
      this._toggleAccordion($(event.currentTarget).parent());
    });
  }

  onSectionUnload() {
    this.$el.off('.footer');
    this.forms.unload();

    delete this.Accordion;
  }

  onSectionBlockSelect(block) {
    const $block = $(block.el);

    if ($block.hasClass('has-accordion')) {
      this._toggleAccordion($block, true);
    }
  }

  onSectionBlockDeselect(block) {
    const $block = $(block.el);

    if ($block.hasClass('has-accordion')) {
      this._toggleAccordion($block, false);
    }
  }

  _toggleAccordion($block) {
    if (layout.isBreakpoint('L')) {
      return;
    }

    this.Accordion.toggle($block);
  }

  onBreakpointChange(event, breakpoints) {
    if (layout.isBreakpoint('L')) {
      this.Accordion.openAll();
    } else if (breakpoints.previous === 'L' && !layout.isBreakpoint('L')) {
      this.Accordion.closeOpen();
    }
  }
}
